import { render, staticRenderFns } from "./PanelTransactionFailure.vue?vue&type=template&id=3e4cde9c&"
import script from "./PanelTransactionFailure.vue?vue&type=script&lang=ts&"
export * from "./PanelTransactionFailure.vue?vue&type=script&lang=ts&"
import style0 from "./PanelTransactionFailure.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QSeparator});
